export const BaseBackEndURL = process.env.REACT_APP_BaseBackEndURL;

export const BaseLocationURL = "locations/";
export const BaseLocationSreenURL = `${BaseLocationURL}screen/`;
